import type { FC, PropsWithChildren } from 'react';

import { DetailTile, LoadingWrapper } from '@ipen-portal/plugin-common-react';
import { Alert } from '@mui/material';
import { tss } from 'tss-react/mui';

import { LeanixSourceChip } from './LeanixSourceChip';

type Props = {
  error?: null | { message?: string };
  factsheetUrl?: string;
  icon: string;
  isLoading: boolean;
  leanixId?: string;
  title: string;
};

const useStyles = tss.create(({ theme }) => ({
  alert: {
    marginTop: theme.spacing(1),
  },
}));

export const TdhDetailTile: FC<PropsWithChildren<Props>> = ({
  children,
  error,
  factsheetUrl,
  icon,
  isLoading,
  leanixId,
  title,
}) => {
  const { classes } = useStyles();

  return (
    <DetailTile
      action={<LeanixSourceChip factsheetUrl={factsheetUrl} />}
      icon={icon}
      title={title}
    >
      {leanixId
        ? (
            <LoadingWrapper
              error={error?.message}
              loading={isLoading}
              text="Loading data..."
            >
              {children}
            </LoadingWrapper>
          )
        : (
            <Alert className={classes.alert} severity="warning">
              No LeanIX ID found in entity
            </Alert>
          )}
    </DetailTile>
  );
};
